import ComponentLayout from "../../../../src/layouts/component-layout";
import { Box as Container, Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  Container,
  Label,
  PropTableValues,
  React
};